import styled from "styled-components"
import media from "styled-media-query"

export const Home = styled.section`
  display: flex;
  flex-direction: column;

  ${media.greaterThan("large")`
    flex-direction: row;
  `}

  > div:first-of-type {
    padding-right: 2em;
  }
`
